import React, { useRef, useEffect, useState } from "react";
import { Dialog, DialogContent, DialogActions, DialogTitle, Typography, Button, IconButton, Paper, Grid } from "@mui/material";
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close';
// import { deleteCategory } from 'utils/Category'

const PaperComponent = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const DeactivateCategory = ({ open, setOpen, rows, selectedRow, setAlert, setOpenAlert, activate, setActivate }) => {
    const {t} = useTranslation()
    const [name, setName] = useState('')
    const [id, setId] = useState(null)

    useEffect(() => {
        if (open && selectedRow) {

            const selected = rows.find(row => row.id === selectedRow[0])
            setName(selected?.name)
            setId(selectedRow[0])
        }
    }
    , [open, selectedRow, rows])

    const deactivateCategory = (id) => {

        if(id){
            setAlert({
                msg: activate === "Enabled" ? t('custom_reports.category.table.dialog.deactivate.messages.deactivate_success') : t('custom_reports.category.table.dialog.deactivate.messages.activate_success'),
                severity: 'success'
            })
            setOpenAlert(true)
            setOpen(false)
            setActivate('Disabled')
        } else {
            setAlert({
                msg: activate === "Enabled" ? t('custom_reports.category.table.dialog.deactivate.messages.deactivate_error') : t('custom_reports.category.table.dialog.deactivate.messages.activate_error'),
                severity: 'error'
            })
            setOpenAlert(true)
            setOpen(true)
            setActivate('Enabled')
        }
        /* try{
            const response = deleteCategory(id)
            if(response.status_code === 200){
                setAlert({
                    msg: t('custom_reports.category.table.dialog.deactivate.messages.success'),
                    severity: 'success'
                })
                setOpenAlert(true)
                setOpen(false)
            }
        }catch(error){
            console.error(error)
            setAlert({
                msg: t('custom_reports.category.table.dialog.deactivate.messages.error'),
                severity: 'error'
            })
            setOpenAlert(true)
            setOpen(true)
        } */

    }

    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
            PaperComponent={PaperComponent}
            onClose={(event, reason) =>{
                if(reason !== 'backdropClick') {
                    return;
                }
                setOpen(false)
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{t('custom_reports.category.table.dialog.deactivate.title')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
        <DialogContent dividers>
            <Grid container>
                <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }}>
                    {`${name}`}
                    <Typography variant="body1">{t('custom_reports.category.table.dialog.deactivate.messages.activate')}</Typography>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="error" onClick={() => setOpen(false)}>{t('custom_reports.category.table.dialog.deactivate.buttons.cancel')}</Button>
            <Button variant="contained" color="primary" onClick={() => deactivateCategory(id)}>{activate === 'Enabled' ? t('custom_reports.category.table.dialog.deactivate.buttons.deactivate') : t('custom_reports.category.table.dialog.deactivate.buttons.activate')}</Button>
        </DialogActions>
        </Dialog>
    )
}

export { DeactivateCategory };